import * as THREE from 'three';

export function buildGliderMesh(outfitHue: number): THREE.Group {
  const group = new THREE.Group();
  group.name = 'gliderGroup';

  // Wing shape using ExtrudeGeometry
  const shape = new THREE.Shape();
  shape.moveTo(0, 0.8);      // forward tip
  shape.lineTo(-1.3, -0.5);  // left wingtip
  shape.lineTo(-0.4, -0.2);  // left inner
  shape.lineTo(0, -0.1);     // center
  shape.lineTo(0.4, -0.2);   // right inner
  shape.lineTo(1.3, -0.5);   // right wingtip
  shape.lineTo(0, 0.8);      // close

  const wingGeo = new THREE.ExtrudeGeometry(shape, { depth: 0.04, bevelEnabled: false });
  const wingMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color().setHSL(outfitHue, 0.72, 0.55),
    roughness: 0.35,
    metalness: 0.15,
    transparent: true,
    opacity: 0.88,
    side: THREE.DoubleSide,
  });
  const wing = new THREE.Mesh(wingGeo, wingMat);
  wing.rotation.x = -Math.PI / 2; // lay flat
  wing.name = 'gliderWing';
  group.add(wing);

  // Two struts from wing to harness
  const strutMat = new THREE.MeshStandardMaterial({ color: 0x222222, roughness: 0.8 });
  for (const side of [-0.3, 0.3]) {
    const strutGeo = new THREE.CylinderGeometry(0.012, 0.012, 0.65, 4);
    const strut = new THREE.Mesh(strutGeo, strutMat);
    strut.position.set(side, -0.3, 0);
    strut.rotation.z = side > 0 ? 0.15 : -0.15;
    group.add(strut);
  }

  return group;
}
